
import { useCallback } from "react";

interface UseExploreFiltersProps {
  setSelectedSort: (sort: string) => void;
  setSelectedTimeFilter: (timeFilter: string) => void;
  setCurrentPage: (page: number) => void;
  clearCategoryFilter: () => void;
  clearSearch: () => void;
  loadPrompts: () => void;
}

export function useExploreFilters({
  setSelectedSort,
  setSelectedTimeFilter,
  setCurrentPage,
  clearCategoryFilter,
  clearSearch,
  loadPrompts
}: UseExploreFiltersProps) {
  // Handle sort change
  const handleSortChange = useCallback((sort: string) => {
    console.log("Sort changed to:", sort);
    setSelectedSort(sort);
    setCurrentPage(1);
  }, [setSelectedSort, setCurrentPage]);

  // Handle time filter change
  const handleTimeFilterChange = useCallback((timeFilter: string) => {
    console.log("Time filter changed to:", timeFilter);
    setSelectedTimeFilter(timeFilter);
    setCurrentPage(1);
  }, [setSelectedTimeFilter, setCurrentPage]);

  // Clear filters function
  const clearFilters = useCallback(() => {
    console.log("Clearing all filters");
    clearCategoryFilter();
    clearSearch();
    setSelectedSort('relevance');
    setSelectedTimeFilter('');
    setCurrentPage(1);
    
    // Force a reload of prompts after clearing filters
    setTimeout(() => {
      loadPrompts();
    }, 200);
  }, [clearCategoryFilter, clearSearch, setSelectedSort, setSelectedTimeFilter, setCurrentPage, loadPrompts]);

  return {
    handleSortChange,
    handleTimeFilterChange,
    clearFilters
  };
}
